import React from 'react';
import './App.css';
import './styles/responsive.css';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Landing from './pages/Landing';
import ApplicationsPage from './pages/ApplicationsPage';
import AdminPage from './pages/AdminPage';
import SubmittedPage from './pages/SubmittedPage';
import SubmittedApplicationPage from './pages/SubmittedApplicationPage';
import SubmittedProjectPage from './pages/SubmittedProjectPage';
import RequestPage from './pages/RequestPage';
import TeamPage from './pages/TeamPage';
import BmRequestPage from './pages/BmRequestPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CookiesPage from './pages/CookiesPage';
import ClientDashboardPage from './pages/ClientDashboardPageV4';
import ClientLoginPage from './pages/ClientLoginPage';
import CAdminPage from './pages/CAdminPage';
import AssistantLoginPage from './pages/AssistantLoginPage';
import AssistantDashboard from './pages/AssistantDashboard';
import AssistantsAdminPage from './pages/AssistantsAdminPage';
import ExecutivesAdminPage from './pages/ExecutivesAdminPage';
import AssistantWorkManagementPage from './pages/AssistantWorkManagementPage';
import AdminOpsPage from './pages/AdminOpsPage';
import TravelArchivePage from './pages/TravelArchivePage';
import TodoCenter from './pages/TodoCenter';
import ExecutiveHub from './pages/ExecutiveHub';
import CalendarPage from './pages/CalendarPage';
import AssignedClientsPage from './pages/AssignedClientsPage';
import TravelBinderPage from './pages/TravelBinderPage';
import AdminTravelManagement from './pages/AdminTravelManagement';
import MessagingPage from './pages/MessagingPage';
import ExecutiveMessagingPage from './pages/ExecutiveMessagingPage';
import AssistantSettingsPage from './pages/AssistantSettingsPage';
import MiniServicesPage from './pages/MiniServicesPage';
import MiniServicesRequestPage from './pages/MiniServicesRequestPage';
import LaunchBundlesPage from './pages/LaunchBundlesPage';
import NotesPage from './pages/NotesPage';
import MeetingsPage from './pages/MeetingsPage';
import AdminAuthGateUserPass from './components/admin/AdminAuthGateUserPass';
import { Toaster } from './components/ui/sonner';
import { ToastProvider } from './components/Toast';

function App() {
  return (
    <ToastProvider>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/applications" element={<ApplicationsPage />} />
          <Route path="/bundles" element={<LaunchBundlesPage />} />
          <Route path="/quick-fixes" element={<MiniServicesPage />} />
          <Route path="/admin" element={<AdminAuthGateUserPass><AdminPage /></AdminAuthGateUserPass>} />
          <Route path="/cadmin" element={<AdminAuthGateUserPass><CAdminPage /></AdminAuthGateUserPass>} />
          <Route path="/submitted" element={<SubmittedPage />} />
          <Route path="/submitted-application" element={<SubmittedApplicationPage />} />
          <Route path="/submitted-project" element={<SubmittedProjectPage />} />
          <Route path="/request" element={<RequestPage />} />
          <Route path="/mini-services" element={<MiniServicesPage />} />
          <Route path="/mini-services/request" element={<MiniServicesRequestPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/bm-request" element={<BmRequestPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/client-login" element={<ClientLoginPage />} />
          <Route path="/client-dashboard" element={<ClientDashboardPage />} />
          <Route path="/client-dashboard/:clientId" element={<ClientDashboardPage />} />
          <Route path="/assistant-login" element={<AssistantLoginPage />} />
          <Route path="/a-dashboard" element={<AssistantDashboard />} />
          <Route path="/a-dashboard/todo" element={<TodoCenter />} />
          <Route path="/a-dashboard/executives" element={<ExecutiveHub />} />
          <Route path="/a-dashboard/calendar" element={<CalendarPage />} />
          <Route path="/a-dashboard/clients" element={<AssignedClientsPage />} />
          <Route path="/a-dashboard/travel" element={<TravelBinderPage />} />
          <Route path="/a-dashboard/exec-messages" element={<ExecutiveMessagingPage />} />
          <Route path="/a-dashboard/messages" element={<MessagingPage />} />
          <Route path="/a-dashboard/messages/:threadId" element={<MessagingPage />} />
          <Route path="/a-dashboard/meetings" element={<MeetingsPage />} />
          <Route path="/a-dashboard/settings" element={<AssistantSettingsPage />} />
          <Route path="/a-dashboard/notes" element={<NotesPage />} />
          <Route path="/admin/assistants" element={<AdminAuthGateUserPass><AssistantsAdminPage /></AdminAuthGateUserPass>} />
          <Route path="/admin/assistants/:assistantId/work" element={<AdminAuthGateUserPass><AssistantWorkManagementPage /></AdminAuthGateUserPass>} />
          <Route path="/admin/executives" element={<AdminAuthGateUserPass><ExecutivesAdminPage /></AdminAuthGateUserPass>} />
          <Route path="/admin/ops" element={<AdminAuthGateUserPass><AdminOpsPage /></AdminAuthGateUserPass>} />
          <Route path="/admin/travel-archive" element={<AdminAuthGateUserPass><TravelArchivePage /></AdminAuthGateUserPass>} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </ToastProvider>
  );
}

export default App;